import { TableRowDisplayEvent } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { AutogenLayoutDetentionDefaultsList } from "./autogen/AutogenLayoutDetentionDefaultsList";

export class DetentionDefaultsList extends AutogenLayoutDetentionDefaultsList {
    tableDetentionDefaultsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;
        const imageWarning = tableRow.findComponentById("imageWarning");
        if (imageWarning) {
            imageWarning.visible = !modelRow.getBoolean("web_valid", false);
        }
    }
}